const toCamelCase = (str: string) =>
  str
    ?.toLowerCase()
    .replace(/[^a-z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
    .trim();

export default toCamelCase;
